import { render, staticRenderFns } from "./Sponsors.vue?vue&type=template&id=95a52b38&"
import script from "./Sponsors.vue?vue&type=script&lang=ts&"
export * from "./Sponsors.vue?vue&type=script&lang=ts&"
import style0 from "./Sponsors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports